__webpack_require__.p = "https://static.ngs.ru/jtnews/dist/legacy/";